import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable, catchError, throwError } from 'rxjs';
import { DocumentDetailsMetaEntity } from '../state/document-details-meta.models';

@Injectable({
  providedIn: 'root',
})
export class DocumentDetailsMetaService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getDocumentDetailsMeta(
    categoryId: number,
    documentId: number,
    language: string
  ): Observable<DocumentDetailsMetaEntity> {
    const url = `${this.apiData.apiURL}api/${this.client}/category/${categoryId}/document/${documentId}/${language}/meta`;

    return this.http.post<DocumentDetailsMetaEntity>(url, {}).pipe(
      catchError((error) => {
        console.error('Error fetching document meta infos:', error);
        return throwError(() => new Error('Failed to load document meta infos'));
      })
    );
  }
}
